module.exports = __webpack_public_path__ + "img/icon2-prizeAsset-3.f11a65d5.svg";